import React from 'react';
import { ArrowRightIcon } from 'lucide-react';
import { CHECKOUT_URL } from '../data/content';
type Props = {
  text: string;
  variant?: 'light' | 'dark';
};

/**
 * "Botón transformacional" — a short benefit-led CTA placed at the end of each section.
 */
export function TransformCTA({
  text,
  variant = 'light'
}: Props) {
  const isDark = variant === 'dark';
  return <div className="mt-10 flex justify-center px-1" data-id="element-258" data-mp="2uwwdyq0g5rxu">
      <a href={CHECKOUT_URL} className={['group flex w-full max-w-md items-center justify-between gap-3 rounded-2xl border-2 px-4 py-3.5 text-left transition-colors', isDark ? 'border-white/25 bg-white/10 text-white hover:bg-white/20' : 'border-navy/15 bg-white text-navy hover:border-brandred hover:bg-brandred/5'].join(' ')} data-id="element-259" data-mp="275qw65ay4pkw">
        <span className="text-[13px] sm:text-sm font-bold leading-snug" data-id="element-260" data-mp="3sgr0lmqzt9x5">{text}</span>
        <span className={['flex h-9 w-9 shrink-0 items-center justify-center rounded-full transition-transform group-hover:translate-x-1', isDark ? 'bg-white text-navy' : 'bg-brandred text-white'].join(' ')} data-id="element-261" data-mp="3ni61jqnh8waa">
          <ArrowRightIcon className="h-4 w-4" strokeWidth={3} data-id="element-262" data-mp="4in4iycv8bwm" />
        </span>
      </a>
    </div>;
}